import find from "lodash/find";
import get from "lodash/get";

/**
 * @param {string} inputField
 * @param {?object} value
 * @return {function / object / null}
 */
export function setInputField(inputField, value) {
  switch (inputField) {
  case "CATEGORY":
    return { type: "SET_CATEGORY", payload: value };
  case "COMPETITIVEREPLACEMENT":
  case "COMPETITIVE_REPLACEMENT":
    return { type: "SET_COMPETITIVE_REPLACEMENT", payload: value };
  case "ONSITE":
    return { type: "SET_ONSITE", payload: value };
  case "ONSITEDETAIL":
  case "ONSITE_DETAIL":
    return { type: "SET_ONSITE_DETAIL", payload: value };
  case "HOURS":
    return { type: "SET_DURATION", payload: value };
  case "ACCOUNT":
    return setAccount(value);
  case "PRODUCTGROUP":
    return { type: "SET_PRODUCT_GROUP", payload: value };
  case "PRODUCTLINE":
    return { type: "SET_PRODUCT_LINE", payload: value };
  case "DISTRIBUTOR":
    return { type: "SET_DISTRIBUTOR", payload: value };
  case "LOCATION":
    return { type: "SET_LOCATION", payload: value };
  case "OPPORTUNITY":
    return { type: "SET_OPPORTUNITY", payload: value };
  case "OPPORTUNITY_AMOUNT":
    return { type: "SET_OPPORTUNITY_AMOUNT", payload: value };
  case "INTERLOCK":
    return { type: "SET_INTERLOCK", payload: value };
  case "SERVICEREQUEST":
    return { type: "SET_SERVICE_REQUEST", payload: value };
  default:
    console.warn("Tried to set unknown input field: %s", inputField);
    return null;
  }
};

/**
 * Update an account in the store, ensuring that the location
 * is accounted for and the opportunity is cleared.
 *
 * @param {?object} account
 * @return {function}
 */
function setAccount(account) {
  return function _setAccount(dispatch, getState) {
    const state = getState();

    const location = locationFromAccount(state, account);

    dispatch({ type: "SET_ACCOUNT", payload: account });
    dispatch(setInputField("LOCATION", location));
    dispatch(setInputField("OPPORTUNITY", null));
  };
}

/**
 * Extract the location to set when updating an account
 * based on user preferences.
 *
 * @param {object} state
 * @param {?object} account
 * @return {?object}
 */
function locationFromAccount(state, account) {
  if (!account) {
    return null;
  }

  const locations = get(account, "locations");

  if (Array.isArray(locations)) {
    const preferredLocationId = get(
      ["user", "preferences", "locationPrefs", account.accountId]
    );

    if (locations.length === 1 && locations[0]) {
      return locations[0];
    } else if (preferredLocationId) {
      return find(locations, ["standardLocationId", preferredLocationId]);
    }
  }

  return null;
}



// WEBPACK FOOTER //
// ./app/actions/fieldInputActions.js